/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiError,
    ApiErrorFromJSON,
    ApiErrorFromJSONTyped,
    ApiErrorToJSON,
} from './ApiError';

/**
 * 
 * @export
 * @interface WorkspaceMembersBatchDeleteResponseItem
 */
export interface WorkspaceMembersBatchDeleteResponseItem {
    /**
     * An HTTP status code indicating the status of the request for an invited, removed, or updated workspace member.
     * @type {number}
     * @memberof WorkspaceMembersBatchDeleteResponseItem
     */
    statusCode: number;
    /**
     * The email address of the workspace member.
     * @type {string}
     * @memberof WorkspaceMembersBatchDeleteResponseItem
     */
    email: string;
    /**
     * 
     * @type {ApiError}
     * @memberof WorkspaceMembersBatchDeleteResponseItem
     */
    error?: ApiError;
}

export function WorkspaceMembersBatchDeleteResponseItemFromJSON(json: any): WorkspaceMembersBatchDeleteResponseItem {
    return WorkspaceMembersBatchDeleteResponseItemFromJSONTyped(json, false);
}

export function WorkspaceMembersBatchDeleteResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMembersBatchDeleteResponseItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statusCode': json['statusCode'],
        'email': json['email'],
        'error': !exists(json, 'error') ? undefined : ApiErrorFromJSON(json['error']),
    };
}

export function WorkspaceMembersBatchDeleteResponseItemToJSON(value?: WorkspaceMembersBatchDeleteResponseItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statusCode': value.statusCode,
        'email': value.email,
        'error': ApiErrorToJSON(value.error),
    };
}

